import request from '@/utils/request'

// 添加产品服务命令
export function addIotServiceCommand(data) {
    return request({
      url: '/iot/servicecommand/add',
      method: 'post',
      data: data
    })
}

// 获取产品服务命令
export function getIotServiceCommand(id) {
    return request({
      url: '/iot/servicecommand/get?id=' + id,
      method: 'get'
    })
}

// 更新产品服务命令
export function updateIotServiceCommand(data) {
    return request({
      url: '/iot/servicecommand/update',
      method: 'post',
      data: data
    })
  }
  
// 删除产品服务命令
export function delIotServiceCommand(id) {
    return request({
      url: '/iot/servicecommand/del',
      method: 'post',
      data: {
        ids: id
      }
    })
  }
// 产品服务命令列表
export function listIotServiceCommand(query) {
  return request({
    url: '/iot/servicecommand/list',
    method: 'get',
    params: query
  })
}